/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-empty-pattern */
import { on, createReducer } from '@ngrx/store';

import { HelperService } from 'app/core/services/helper.service';
import { DeliveryAsset } from 'app/core/models/delivery-asset.model';
import * as fromActions from '../actions/delivery-assets.actions';

export interface DeliveryAssetState {
  assets: DeliveryAsset[];
  isPlayingAll: boolean;
  loading: boolean;
  isDefaultView: boolean;
  isDownloadingAll: boolean;
  isInfoView: boolean;
}

export const initialState: DeliveryAssetState = {
  assets: [],
  isPlayingAll: false,
  loading: false,
  isDefaultView: true,
  isDownloadingAll: false,
  isInfoView: true,
};

export const reducer = createReducer(
  initialState,
  on(fromActions.LoadAsset, (state: DeliveryAssetState, {}) => {
    const assets = [];

    return { ...state, assets, loading: true };
  }),
  on(fromActions.SetAssetState, (state: DeliveryAssetState, { payload }) => {
    return { ...payload, loading: false };
  }),
  on(fromActions.LoadAssetFail, (state: DeliveryAssetState, {}) => ({ ...state, loading: false })),
  on(fromActions.SetSelectedAsset, (state: DeliveryAssetState, { payload }) => {
    const isDefaultView = false;
    const isInfoView = true;
    const assets = selectAsset(state.assets, payload);

    return { ...state, assets, isDefaultView, isInfoView };
  }),
  on(fromActions.TogglePlaying, (state: DeliveryAssetState, { payload }) => {
    const isDefaultView = false;
    const assets = state.assets.map((deliveryAsset: DeliveryAsset) =>
      HelperService.cloneDeliveryAsset(deliveryAsset),
    );
    const isPlayingAll =
      payload && payload.isPlayingAll === undefined ? state.isPlayingAll : payload.isPlayingAll;

    assets.forEach((asset: DeliveryAsset) => {
      asset.resetPlay = false;
      if (asset.isSelected) {
        asset.isPlaying = payload.play;
      }
    });

    return { ...state, isDefaultView, isPlayingAll, assets };
  }),
  on(fromActions.SetReadyForPlaying, (state: DeliveryAssetState, { payload }) => {
    const assets = state.assets.map((deliveryAsset: DeliveryAsset) =>
      HelperService.cloneDeliveryAsset(deliveryAsset),
    );

    assets.forEach((asset: DeliveryAsset) => {
      if (asset.isSelected) {
        asset.isReadyToPlay = payload;
      }
    });

    return { ...state, assets };
  }),
  on(fromActions.SetPlayingAll, (state: DeliveryAssetState, { payload }) => (
    { ...state, isPlayingAll: payload }
  )),
  on(fromActions.AllowDownload, (state: DeliveryAssetState, { payload }) => {
    const assets = state.assets.map((deliveryAsset: DeliveryAsset) => {
      const asset = HelperService.cloneDeliveryAsset(deliveryAsset);

      if (asset.campaignTrackId === payload) {
        asset.isDownloaded = false;
      }

      return asset;
    });

    return { ...state, assets };
  }),
  on(fromActions.AllowDownloadAll, (state: DeliveryAssetState, {}) => {
    const assets = state.assets.map((asset: DeliveryAsset) => {
      const modifiedAsset = HelperService.cloneDeliveryAsset(asset);
      modifiedAsset.isDownloaded = false;
      return modifiedAsset;
    });

    return { ...state, assets };
  }),
  on(
    fromActions.ToggleDownloading,
    fromActions.ToggleCdnDownloading,
    fromActions.ToggleDownloadAllFormats,
    (state: DeliveryAssetState, { payload }) => {
      const assets = state.assets.map((deliveryAsset: DeliveryAsset) =>
        HelperService.cloneDeliveryAsset(deliveryAsset),
      );
      const asset = assets.find(
        (item: DeliveryAsset) => item.campaignTrackId === payload.campaignTrackId,
      );

      if (asset) {
        asset.isDownloading = true;
      }

      return { ...state, assets };
    },
  ),
  on(fromActions.DownloadingFail, (state: DeliveryAssetState, { payload }) => {
    const assets = state.assets.map((deliveryAsset: DeliveryAsset) => {
      const asset: DeliveryAsset = HelperService.cloneDeliveryAsset(deliveryAsset);

      if (asset.campaignTrackId === payload) {
        asset.isDownloading = false;
        asset.isDownloaded = false;
      }
      return asset;
    });

    return { ...state, assets };
  }),
  on(fromActions.ToggleDownloadAll, (state: DeliveryAssetState, {}) => {
    const assets = state.assets.map((asset: DeliveryAsset) => {
      const modifiedAsset = HelperService.cloneDeliveryAsset(asset);
      if (modifiedAsset.isAllowedToDownload) {
        modifiedAsset.isDownloading = true;
      }
      return modifiedAsset;
    });

    return { ...state, assets, isDownloadingAll: true };
  }),
  on(fromActions.DownloadingSuccess, (state: DeliveryAssetState, { payload }) => {
    const assets = state.assets.map((deliveryAsset: DeliveryAsset) =>
      HelperService.cloneDeliveryAsset(deliveryAsset),
    );
    const asset = assets.find((item: DeliveryAsset) => item.campaignTrackId === payload);

    if (asset) {
      asset.isDownloading = false;
      asset.isDownloaded = true;
    }

    return { ...state, assets };
  }),
  on(fromActions.DownloadingAllFail, (state: DeliveryAssetState, {}) => {
    const assets = [...state.assets].map((asset: DeliveryAsset) => {
      const modifiedAsset = HelperService.cloneDeliveryAsset(asset);
      modifiedAsset.isDownloading = false;
      modifiedAsset.isDownloaded = false;
      return modifiedAsset;
    });

    return { ...state, assets, isDownloadingAll: false };
  }),
  on(fromActions.DownloadingAllSuccess, (state: DeliveryAssetState, {}) => {
    const assets = [...state.assets].map((asset: DeliveryAsset) => {
      const modifiedAsset = HelperService.cloneDeliveryAsset(asset);

      if (modifiedAsset.isAllowedToDownload) {
        modifiedAsset.isDownloading = false;
        modifiedAsset.isDownloaded = true;
      }
      return modifiedAsset;
    });

    return { ...state, assets, isDownloadingAll: false };
  }),

  on(fromActions.CancelDownloading, (state: DeliveryAssetState, { payload }) => {
    const assets = state.assets.map((deliveryAsset: DeliveryAsset) =>
      HelperService.cloneDeliveryAsset(deliveryAsset),
    );
    const asset = assets.find((item: DeliveryAsset) => item.campaignTrackId === payload);

    if (asset) {
      asset.isDownloading = false;
      asset.isDownloaded = false;
    }

    return { ...state, assets };
  }),

  on(fromActions.ClearSelectedAsset, (state: DeliveryAssetState, {}) => {
    const assets = state.assets.map((asset: DeliveryAsset) => {
      const modifiedAsset = HelperService.cloneDeliveryAsset(asset);

      modifiedAsset.isSelected = false;

      return modifiedAsset;
    });
    return { ...state, assets };
  }),
  on(fromActions.SetDefaultView, (state: DeliveryAssetState, { payload }) => {
    const { isDefaultView } = payload;
    return { ...state, isDefaultView };
  }),
  on(fromActions.SetLoadingState, (state: DeliveryAssetState, { payload }) => (
    { ...state, loading: payload }
  )),
  on(fromActions.ToggleTabs, (state: DeliveryAssetState, { payload }) => (
    { ...state, isInfoView: payload }
  )),
  on(fromActions.LoadMoreAssetSuccess, (state: DeliveryAssetState, { payload }) => {
    const assets = [...payload.assets, ...state.assets];

    return { ...state, assets };
  }),
  on(fromActions.ResetPlay, (state: DeliveryAssetState, { payload }) => {
    const assets = state.assets.map((currentAsset: DeliveryAsset) => {
      const modifiedAsset = HelperService.cloneDeliveryAsset(currentAsset);
      const asset = payload;

      if (modifiedAsset.campaignTrackId === asset.campaignTrackId) {
        modifiedAsset.isPlaying = true;
        modifiedAsset.resetPlay = true;
      } else {
        modifiedAsset.resetPlay = false;
      }

      return modifiedAsset;
    });
    return { ...state, assets };
  }),
);

function selectAsset(assets, selectedAsset) {
  if (!assets || !assets.length || !selectedAsset) {
    return assets;
  }

  return assets.map((asset: DeliveryAsset) => {
    const modifiedAsset = HelperService.cloneDeliveryAsset(asset);
    if (modifiedAsset.campaignTrackId === selectedAsset.campaignTrackId) {
      modifiedAsset.isSelected = true;
      modifiedAsset.isPlaying = selectedAsset.isPlaying;
    } else {
      modifiedAsset.isSelected = false;
      modifiedAsset.isPlaying = false;
      modifiedAsset.resetPlay = false;
    }

    return modifiedAsset;
  });
}

export const selectPlayingAll = (state: DeliveryAssetState) => state.isPlayingAll;
export const selectLoading = (state: DeliveryAssetState) => state.loading;
export const selectDefaultView = (state: DeliveryAssetState) => state.isDefaultView;
export const selectInfoView = (state: DeliveryAssetState) => state.isInfoView;
